export enum FileType {
    CSV = 'csv',
    PDF = 'pdf',
}
